export default class FollowStatusModel {
  public followsMe: string[] = [];
  public iFollow: string[] = [];
  public followsMeBack: string[] = [];
}
